import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography }: Theme) =>
  createStyles({
    rootTabs: {
      width: '100%',
      borderBottom: `1px solid ${palette.lightGray}`,
    },
    tabs: {
      minHeight: 40,

      '& .MuiTabs-indicator': {
        background: palette.darkGray,
      },
    },

    checkboxCell: {
      padding: '0 0 0 8px',

      '& .MuiCheckbox-root': {
        padding: 0,
      },

      '& span > span > svg': { width: 15, height: 15 },
    },

    headerContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end',
      margin: '10px 0',
    },

    removeButton: {
      background: palette.error.main,
      color: palette.error.contrastText,
      marginRight: 8,
      fontSize: 12,
      padding: '5px 8px',

      '&:hover': {
        background: palette.error.dark,
      },

      '& .MuiButton-startIcon': {
        marginRight: '0 !important',
      },
    },

    tab: {
      fontSize: 12,
      fontWeight: 500,
      color: palette.darkGray,
      minHeight: 40,

      '&:hover': {
        textDecoration: 'none',
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
      },
    },

    table: {
      '& .MuiTableHead-root': {
        background: 'transparent',
      },
      '& .MuiTableRow-root': {
        height: 40,
      },
      '& .MuiTableCell-root': {
        fontSize: 12,
        color: palette.darkGray,
        fontWeight: typography.fontWeightMedium,
      },
      '& .MuiTableCell-head': {
        fontWeight: typography.fontWeightRegular,
      },

      '& a': {
        textDecoration: 'none',
        color: palette.blue,
      },
    },

    buttonRemove: {
      color: palette.error.light,
      '&:hover': {
        color: palette.error.main,
      },
      borderColor: palette.black,
      padding: '2px !important',
    },

    iconFormat: {
      color: palette.deepBlue,
    },
    strong: {
      fontWeight: 'bold',
    },

    buttons: {
      margin: '40px auto 16px',

      '& .MuiButtonBase-root': {
        margin: '0 8px',
      },
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      padding: '10px 0px 4px',
    },

    text: {
      fontSize: 12,
    },
  });
